// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__IYSk6","container":"style_container__trinI","box":"style_box__Tr5Sc"};